/**
 * Shop summary (`apiV4ShopSummaryPost`) failure `ErrorCode.code` when the
 * destination/route is not eligible for grid (fixed-points) pricing per RBC rules.
 *
 * @see ErrorCode in @b2bportal/air-shopping-api
 */
export const SHOP_SUMMARY_ERROR_ROUTE_NOT_ALLOWED_FOR_FIXED_POINTS_PRICING =
  "RouteNotAllowedForFixedPointsPricing" as const;

/**
 * Shop summary (`apiV4ShopSummaryPost`) failure `ErrorCode.code` when the user
 * has insufficient points balance for fixed-points pricing.
 *
 * @see ErrorCode in @b2bportal/air-shopping-api
 */
export const SHOP_SUMMARY_ERROR_INSUFFICIENT_POINTS_BALANCE =
  "InsufficientPointsBalanceForFixedPointsPricing" as const;
